module.exports = __webpack_public_path__ + "static/img/bird11.b768a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird11.png
// module id = iUol
// module chunks = 1